var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-full-screen-container',{staticClass:"main-wrapper"},[_c('main',{staticClass:"main-wrapper__content"},[_c('common-header'),_c('section',{staticClass:"app-main"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }